export default __webpack_public_path__ + "static/media/Stripes_Loader.7f3e8649.svg";